import { Link } from '@chakra-ui/next-js';
import { Highlight, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { FC, ReactNode } from 'react';
import { brand } from '@/shared/constants';
import { CheckboxField } from '@/shared/ui';

const UserAgreementFields: FC<{ name?: string; children?: ReactNode }> = ({
  children,
  name = 'isConsent',
}) => {
  const { t } = useTranslation();

  return (
    <>
      <CheckboxField
        Label={
          <Text textAlign='left'>
            <Highlight
              query={[brand]}
              styles={{ color: 'primary.pure' }}
            >
              {t('modals.userAgreement.consentText', { brand })}
            </Highlight>
          </Text>
        }
        name={name}
      />
      {children}
      <Text
        fontSize='sm'
        mt='lg'
      >
        {t('modals.userAgreement.submitText')}{' '}
        <Link
          color='primary.pure'
          href='/terms'
          target='_blank'
        >
          {t('modals.userAgreement.userAgreement')}
        </Link>{' '}
        {t('modals.userAgreement.and')}{' '}
        <Link
          color='primary.pure'
          href='/privacy'
          target='_blank'
        >
          {t('modals.userAgreement.privacyPolicy')}
        </Link>
      </Text>
    </>
  );
};

export default UserAgreementFields;
